import React, { memo, useEffect, useContext, useRef } from "react";
import { MAPBOX_API_KEY } from "@/misc/constants";
import * as ReactMapbox from "react-mapbox-gl";
import MapboxLang from "@mapbox/mapbox-gl-language";
import Mapbox from "mapbox-gl";
import PT from "prop-types";
import { ThemeContext } from "styled-components";
import s from "styled-components";
import "mapbox-gl/dist/mapbox-gl.css";

const MapInstance = ReactMapbox.Map({
  accessToken: MAPBOX_API_KEY,
});
export const Layer = ReactMapbox.Layer;
export const Feature = ReactMapbox.Feature;
export const Popup = ReactMapbox.Popup;
export const Marker = ReactMapbox.Marker;

export const Context = ReactMapbox.MapContext;
const Controls = (props) => {
  const map = useContext(Context);
  useEffect(() => {
    if (map) {
      const lang = new MapboxLang({
        defaultLanguage: props.lang,
      });
      map.addControl(lang);
    }
  }, []);
  useEffect(() => {
    if (map) {
      map.addControl(new Mapbox.FullscreenControl());
    }
  }, []);
  return null;
};
const Icons = () => {
  const map = useContext(Context);
  useEffect(() => {
    if (map) {
      map.loadImage("/icons/premium_map.png", (error, img) => {
        if (error) {
          console.error(error);
        } else {
          map.addImage("premium", img);
        }
      });
    }
  }, []);
  return null;
};
export const Map = memo((props) => {
  const theme = useContext(ThemeContext);
  return (
    <MapInstance
      style={
        theme.__name__ === "dark"
          ? "mapbox://styles/mapbox/dark-v10"
          : "mapbox://styles/mapbox/streets-v10"
      }
      containerStyle={props.style}
      center={props.center}
    >
      <Controls lang={props.lang || props.locale} />
      <Icons />
      {props.children}
    </MapInstance>
  );
});
Map.displayName = "Map";
Map.propTypes = {
  center: PT.array,
  tile: PT.string,
  style: PT.object,
  lang: PT.string,
};
Map.defaultProps = {
  tile: "mapbox://styles/mapbox/streets-v10",
  style: {
    height: "100%",
    width: "100%",
  },
  lang: "ru",
};
const StyledDraggableMarker = s.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--color-primary);
  border: 4px solid white;
`;
export const DraggableMarker = (props) => {
  const map = useContext(Context);
  const markerRef = useRef(null);
  const wrapRef = useRef(null);
  useEffect(() => {
    let marker;
    const onDragEnd = () => {
      const lngLat = marker.getLngLat();
      props.onDragEnd && props.onDragEnd(lngLat);
    };
    if (map) {
      if (!markerRef.current) {
        marker = new Mapbox.Marker({
          draggable: true,
          element: wrapRef.current,
        })
          .setLngLat(props.coords)
          .addTo(map);
        markerRef.current = marker;
      } else {
        marker = markerRef.current;
      }
      marker.on("dragend", onDragEnd);
    }
    return () => {
      if (marker) {
        marker.off("dragend", onDragEnd);
      }
    };
  }, [props.onDragEnd]);
  useEffect(() => {
    return () => {
      if (markerRef.current) {
        markerRef.current.remove();
        markerRef.current = undefined;
      }
    };
  }, []);
  useEffect(() => {
    if (markerRef.current) {
      markerRef.current.setLngLat(props.coords);
    }
  }, [props.coords]);
  return (
    <div ref={wrapRef}>
      <StyledDraggableMarker />
    </div>
  );
};
DraggableMarker.propTypes = {
  coords: PT.array,
  onDragEnd: PT.func,
};
